import MoveTo from "moveto";

if (document.body.classList.contains("contact")) {
    document.querySelector("html").style.scrollBehavior = "auto"
    const moveTo = new MoveTo({
        duration: 300,
        tolerance: window.innerWidth * 0.1
    });
    const triggers = document.querySelectorAll('a[href^="#"]');;
    for (var i = 0; i < triggers.length; i++) {
        moveTo.registerTrigger(triggers[i]);
    }
}

